<div class="dialog-header">
  <div>
    <h2>Tourendetails</h2>
    <p class="subtitle">
      {{ info.date | date: 'd.M.yyyy' }} · Tour {{ info.time }} / {{ info.suffix }} ·
      {{ tour.package.length }} Packungen · {{ totalLines }} Artikel gesamt
    </p>
  </div>
  <button mat-icon-button mat-dialog-close aria-label="Schließen">
    <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
  </button>
</div>

<mat-form-field appearance="outline" class="m-m" subscriptSizing="dynamic">
  <mat-icon matPrefix fontSet="material-symbols-outlined">search</mat-icon>
  <input matInput placeholder="PZN oder Artikelname suchen…"
         [value]="query()" (input)="query.set($any($event.target).value)"/>
</mat-form-field>
<div>
  @for (doc of visible(); track doc.no) {
    <section class="doc">
      <div class="doc-head">
        <div class="doc-title">
          <mat-icon fontSet="material-symbols-outlined">description</mat-icon>
          <strong>{{ doc.no }}</strong>
          <span class="doc-type">{{ doc.label }}</span>
          <span class="badge">{{ doc.lines.length }} Artikel</span>
        </div>

        <button mat-button type="button" class="download" (click)="download(doc.no)">
          <mat-icon fontSet="material-symbols-outlined">download</mat-icon>
          Herunterladen
        </button>
      </div>

      <table class="doc-table">
        <thead>
        <tr>
          <th>PZN</th>
          <th>Artikelbezeichnung</th>
          <th class="num">Menge</th>
        </tr>
        </thead>
        <tbody>
          @for (line of doc.lines; track $index) {
            <tr>
              <td>{{ line.article_code }}</td>
              <td>{{ line.article_name }}</td>
              <td class="num">{{ line.expected_delivery_quantity }}</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  } @empty {
    <p>Keine Treffer.</p>
  }
</div>
